import type { EagColumnState } from '../../types/EagColumnState';
import { selectColumnStates } from '../createEagGridStore';
import { useEagGridSelector } from '../useEagGridSelector';
export function useColumnStates(): EagColumnState[] {
  return useEagGridSelector(selectColumnStates);
}